/* Theme Sauce — buzzwoo E-Com Kitchen
   Bodnik · Description Truncate (<bw-truncate>)
   Eigenständiges Expand/Collapse-Element für den Produkt-Description-Block.
   Bewusst KEIN Reuse von Ignites <content-truncator> (das kann nur ausklappen).

   Fix 2026-09-02: Overflow-Erkennung lief nur einmal beim Connect + bei window.resize.
   Bei ungecachten Seitenaufrufen (eingeloggte / B2B-Kunden) kam das deferred JS teils
   vor dem CSS bzw. vor Fonts/Bildern → scrollHeight == clientHeight → kein Overflow
   erkannt → Button blieb per CSS auf display:none, Text aber gekürzt.
   Jetzt: ResizeObserver auf Wrap + Inhalt, Re-Check nach load/fonts.ready, und keine
   Bewertung solange das Element nicht gelayoutet ist (clientHeight 0). */
if (!customElements.get('bw-truncate')) {
  const debounce = (fn, wait) => {
    let timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, wait);
    };
  };

  class BwTruncate extends HTMLElement {
    connectedCallback() {
      this.wrap = this.querySelector('.bw-truncate__wrap');
      this.btn = this.querySelector('.bw-truncate__btn');
      if (!this.wrap || !this.btn) return;
      this.content = this.wrap.firstElementChild;
      this.moreLabel = this.dataset.more || 'Show more';
      this.lessLabel = this.dataset.less || 'Show less';
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this._onClick = this.toggle.bind(this);
      this._evaluate = this.evaluate.bind(this);
      this._onResize = debounce(this._evaluate, 150);
      this._onTransitionEnd = () => {
        if (this.classList.contains('bw-truncate--open')) this.wrap.style.maxHeight = 'none';
      };

      this.evaluate();
      this.btn.addEventListener('click', this._onClick);
      this.wrap.addEventListener('transitionend', this._onTransitionEnd);

      // Größenänderungen von Wrap (CSS max-height greift verspätet) und Inhalt
      // (Fonts, Bilder, App-Injections) → neu bewerten. Fallback: window.resize.
      if ('ResizeObserver' in window) {
        this._ro = new ResizeObserver(this._onResize);
        this._ro.observe(this.wrap);
        if (this.content) this._ro.observe(this.content);
      } else {
        window.addEventListener('resize', this._onResize);
      }

      // Nachladende Ressourcen, die die Inhaltshöhe ändern
      if (document.readyState !== 'complete') window.addEventListener('load', this._evaluate, { once: true });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(this._evaluate);
    }

    disconnectedCallback() {
      if (this._ro) this._ro.disconnect();
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      if (this._evaluate) window.removeEventListener('load', this._evaluate);
      if (this.btn && this._onClick) this.btn.removeEventListener('click', this._onClick);
      if (this.wrap && this._onTransitionEnd) this.wrap.removeEventListener('transitionend', this._onTransitionEnd);
    }

    evaluate() {
      if (!this.isConnected || this.classList.contains('bw-truncate--open')) return;
      // Nicht gelayoutet (display:none-Container, noch kein Render) → keine Aussage möglich,
      // Zustand nicht anfassen; der ResizeObserver meldet sich, sobald Höhe da ist.
      if (this.wrap.clientHeight === 0) return;
      const overflows = this.wrap.scrollHeight > this.wrap.clientHeight + 4;
      this.classList.toggle('bw-truncate--has-overflow', overflows);
    }

    toggle() {
      const willOpen = !this.classList.contains('bw-truncate--open');
      // Aktuelle Pixelhöhe setzen, damit die Transition einen Startwert hat
      this.wrap.style.maxHeight = this.wrap.scrollHeight + 'px';
      if (willOpen) {
        this.classList.add('bw-truncate--open');
        this.btn.textContent = this.lessLabel;
        this.btn.setAttribute('aria-expanded', 'true');
        // Bei deaktivierten Transitions feuert transitionend nie -> sofort freigeben
        if (this.reduceMotion) this.wrap.style.maxHeight = 'none';
      } else {
        // Reflow erzwingen, dann auf die eingeklappte Höhe (CSS-Var) zurück
        void this.wrap.offsetHeight;
        this.wrap.style.maxHeight = '';
        this.classList.remove('bw-truncate--open');
        this.btn.textContent = this.moreLabel;
        this.btn.setAttribute('aria-expanded', 'false');
      }
    }
  }
  customElements.define('bw-truncate', BwTruncate);
}
